import { CONDITION_SAFE_PLAY_ID } from 'apiConstants';
import { type AuthenticatedUserInterface, SafePlayStatus } from 'typedefs/authTypes';

export const AuthenticatedUser: AuthenticatedUserInterface = {
  BirthDate: '01-01-1970',
  Conditions: [
    {
      ConditionID: '1823618923789',
      OptedOut: false,
      Data: 'test',
    },
    {
      ConditionID: CONDITION_SAFE_PLAY_ID,
      OptedOut: false,
      Data: SafePlayStatus.Approved,
    },
  ],
  EmailAddress: 'test@test.test',
  ExternalID: '456a29f8-9bbd-4353-9425-0f21700c984a',
  FirstName: 'John',
  ID: '456a29f8-9bbd-4353-9425-0f21700c984a',
  IsFemale: false,
  LastName: 'Smith',
  Status: 1,
  SystemRoles: 2,
  VenueContacts: [
    {
      PrivatePIN: '87543857',
      VenueContactID: '1111',
      VenueID: '12312311',
      VenueSystemRoles: 1,
    },
  ],
};
